import EmailGmailIcon from "@Shared/@Assets/icon/connected-email-gmail.svg";
import EmailEasIcon from "@Shared/@Assets/icon/connected-email-custom.svg";
import EmailOutlookIcon from "@Shared/@Assets/icon/connected-email-outlook.svg";
import EmailYahooIcon from "@Shared/@Assets/icon/connected-email-yahoo.svg";
import EmailICloudIcon from "@Shared/@Assets/icon/connected-email-icloud.svg";
import EmailCustomIcon from "@Shared/@Assets/icon/connected-email-custom.svg";
export const emailProviderImage = provider => {
  const emailProviderMap = {
    gmail: EmailGmailIcon,
    eas: EmailEasIcon,
    outlook: EmailOutlookIcon,
    yahoo: EmailYahooIcon,
    icloud: EmailICloudIcon,
    custom: EmailCustomIcon
  };
  return emailProviderMap[provider] || emailProviderMap["custom"];
};
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("emailProviderImage", emailProviderImage);
};